// Public exports for shared frontend package.
import { AlertClient } from './clients/AlertClient';
import { AssetsClient } from './clients/AssetsClient';
import { AuthClient } from './clients/AuthClient';
import { BillingClient } from './clients/BillingClient';
import { BookingClient } from './clients/BookingClient';
import { CallClient } from './clients/CallClient';
import { IntegrationClient } from './clients/IntegrationClient';
import { KBClient } from './clients/KBClient';
import { LeadClient } from './clients/LeadClient';
import { LobbyClient } from './clients/LobbyClient';
import { LogClient } from './clients/LogClient';
import { NicheContentClient } from './clients/NicheContentClient';
import { SeederClient } from './clients/SeederClient';
import { TelemetryClient } from './clients/TelemetryClient';
import { TenantClient } from './clients/TenantClient';
import { TextsClient } from './clients/TextsClient';
import { UserClient } from './clients/UserClient';
import { VoiceAdminClient } from './clients/VoiceAdminClient';

/** Singleton AssetsClient provided by the shared package. */
const assetsClient = AssetsClient.GetInstance();
/** Singleton AlertClient provided by the shared package. */
const alertClient = AlertClient.GetInstance();
/** Singleton AuthClient provided by the shared package. */
const authClient = AuthClient.GetInstance();
/** Singleton LobbyClient provided by the shared package. */
const lobbyClient = LobbyClient.GetInstance();
/** Singleton LogClient provided by the shared package. */
const logClient = LogClient.GetInstance();
/** Singleton UserClient provided by the shared package. */
const userClient = UserClient.GetInstance();
/** Singleton SeederClient provided by the shared package. */
const seederClient = SeederClient.GetInstance();
/** Singleton TenantClient provided by the shared package. */
const tenantClient = TenantClient.GetInstance();
/** Singleton CallClient provided by the shared package. */
const callClient = CallClient.GetInstance();
/** Singleton LeadClient provided by the shared package. */
const leadClient = LeadClient.GetInstance();
/** Singleton BookingClient provided by the shared package. */
const bookingClient = BookingClient.GetInstance();
/** Singleton KBClient provided by the shared package. */
const kbClient = KBClient.GetInstance();
/** Singleton IntegrationClient provided by the shared package. */
const integrationClient = IntegrationClient.GetInstance();
/** Singleton BillingClient provided by the shared package. */
const billingClient = BillingClient.GetInstance();
/** Singleton NicheContentClient provided by the shared package. */
const nicheContentClient = NicheContentClient.GetInstance();
/** Singleton VoiceAdminClient provided by the shared package. */
const voiceAdminClient = VoiceAdminClient.GetInstance();
/** Singleton TextsClient provided by the shared package. */
const textsClient = TextsClient.GetInstance();
/** Singleton TelemetryClient provided by the shared package. */
const telemetryClient = TelemetryClient.GetInstance();

export { assetsClient as AssetsClient };
export { alertClient as AlertClient };
export { authClient as AuthClient };
export { lobbyClient as LobbyClient };
export { logClient as LogClient };
export { userClient as UserClient };
export { seederClient as SeederClient };
export { tenantClient as TenantClient };
export { callClient as CallClient };
export { leadClient as LeadClient };
export { bookingClient as BookingClient };
export { kbClient as KBClient };
export { integrationClient as IntegrationClient };
export { billingClient as BillingClient };
export { nicheContentClient as NicheContentClient };
export { voiceAdminClient as VoiceAdminClient };
export { textsClient as TextsClient };
export { telemetryClient as TelemetryClient };

export { Settings } from './common/Settings';
export { FrontendConstants } from './common/FrontendConstants';
export { HttpError } from './common/HttpError';
export { Telemetry, TelemetryEvents, TelemetryMediaTypes, TelemetryOutcomes, TelemetryParamNames, TelemetrySources, TelemetryUserPropertyNames } from './common/Telemetry';
export {
  SetRootFontSize,
  RegisterViewportChange,
  GetRootFontSize,
  GetPixelsFromRem,
  GetRemFromPixels,
  GetClientIP,
  GenerateClientUUID,
  RequestFullscreen,
  IsFullscreen,
  IsIOS,
  GetLayout,
  IsValidLocalizationCode,
  GetUserGeoLang,
  GetUserGeoCountry,
  GetUserGeoTimezone,
  GetStoredLanguage,
  SetStoredLanguage,
  GetUserLanguage,
  SetLocalStorage,
  GetLocalStorage,
  SetIndexedDB,
  GetIndexedDB,
  DeleteIndexedDB,
  RequiresFetch,
  ResolveNicheLabels,
  IsBotUserAgent,
  IsBenignNetworkError
} from './common/Helpers';
export type { INicheLabels, INicheLabelSource } from './common/Helpers';

export { AuthProvider } from './providers/AuthProvider';
export { RecordLoggerFrontend } from './internal/RecordLoggerFrontend';
export type { IAuthProvider } from './contracts/IAuthProvider';
export type { IAuthOptions } from './contracts/IAuthOptions';
export type { LayoutValues } from './types/LayoutValues';
export type { ITelemetryIdentityDTO } from './common/Telemetry';
export type { TelemetryParams, TelemetryParamValue } from './clients/TelemetryClient';

// SaaS client request/response types.
export type { IUpdateTenantUserRequest, IUpdateTenantRequest, IOnboardingAccountRequest, IProvisionPhoneRequest } from './clients/TenantClient';
export type { IUserTenantLink, ITenantOwnerLink } from './clients/UserClient';
export type { ICallDetailDTO } from './clients/CallClient';
export type { ITextListItemDTO, ITextDetailDTO } from './clients/TextsClient';
export type {
  ICheckoutRequest,
  ICreatePlanRequest,
  IUpdatePlanDetailsRequest,
  IPlanMeterPriceRequest,
  IHostedURLResponse,
  IUsageMeterTotalDTO,
  IUsageSummaryDTO,
  IAccessDecisionDTO,
  IMarginReportDTO
} from './clients/BillingClient';
export type { ICreateNicheRequest, IUpdateNicheRequest } from './clients/NicheContentClient';
export type { IAutomationJobStatsDTO } from './clients/VoiceAdminClient';
